import React from 'react';

import Layout from '../../components/layout';
import CarCalculator from '../../components/calculators/car';

const DEFAULT_COST = 30000;
const DOWN_PAYMENT_FACTOR = 0.1;
const INSURANCE_FACTOR = 0.005;
const USAGE_COSTS = 200;
const FEES_YEARLY = 300;
const MAINTAINENCE_FACTOR = 0.045;
const DEFAULT_DEPRECIATION_RATE = 10;

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <CarCalculator
            pathname={pathname}
            title="Car Purchase Calculator"
            costOfAsset={DEFAULT_COST}
            downPayment={DEFAULT_COST * DOWN_PAYMENT_FACTOR}
            interestRate={2.5}
            loanPeriod={5}
            salesTax={8}
            insurance={DEFAULT_COST * INSURANCE_FACTOR}
            usageCost={USAGE_COSTS}
            ownershipPeriod={10}
            feesYearly={FEES_YEARLY}
            zipCode={94612}
            maintenenceYearly={DEFAULT_COST * MAINTAINENCE_FACTOR}
            depreciationRate={DEFAULT_DEPRECIATION_RATE}
        />
    </Layout>
);
